import { all, call, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";
import actions from "./actions";
import API from "../../helpers/API";
import Notification from "../../components/notification";
import { formatObject } from "../../helpers/utility";

export function* fetchAppVersions() {
  yield takeEvery(actions.FETCH_APPS, function*(action) {
    try {
      const resp = yield call(API.apps.list);
      const users = yield call(API.users.list, action.payload);
      yield put({
        type: actions.FETCH_APPS_SUCCESS,
        apps: resp.data.apps,
      });
      yield put({
        type: actions.FETCH_APP_USERS_SUCCESS,
        users: users && users.data.users ? users.data.users : [],
      });
    } catch (err) {
      yield call(action.spinHandler, false);
      Notification(
        "error",
        err && err.error
          ? err.error.message
          : "Session timed out. Please login again"
      );
    }
  });
}

export function* saveAppVersion() {
  yield takeEvery(actions.SAVE_APPS, function*(action) {
    try {
      let message;
      let data = new FormData();
      if (action.payload.file && action.payload.file.originFileObj) {
        data.append("file", action.payload.file.originFileObj);
        data.append("filename", action.payload.file.name);
      }
      data.append("version", action.payload.version);
      data.append("option", action.payload.option);
      if (action.payload.option == 2) {
        data.append("users", JSON.stringify(action.payload.users));
      }
      // if (action.payload.school) {
        data.append("school", action?.payload?.school||"");
      // }
      if (action.payload.grade) {
        data.append("grade", action.payload.grade);
      }
      if (action.payload.role) {
        data.append("role", action.payload.role);
      }

      if (action.appId) {
        yield call(API.apps.update, data, action.appId);
        message = "App version updated successfully";
      } else {
        yield call(API.apps.save, data);
        message = "App version added successfully";
      }

      const resp = yield call(API.apps.list);
      yield put({
        type: actions.FETCH_APPS_SUCCESS,
        apps: resp.data.apps,
      });
      yield call(action.cb);
      Notification("success", "App version updated successfully");
    } catch (err) {
      yield call(action.cb, "loader");
      Notification(
        "error",
        err && err.error
          ? err.error.message
          : "Session timed out. Please login again"
      );
    }
  });
}

export function* deleteAppVersion() {
  yield takeEvery(actions.DELETE_APP, function*(action) {
    try {
      yield call(API.apps.delete, action.appId);
      const resp = yield call(API.apps.list);
      yield put({
        type: actions.FETCH_APPS_SUCCESS,
        apps: resp.data.apps,
      });
      Notification("success", "App version deleted successfully");
      yield call(action.spinHandler, false);
    } catch (err) {
      yield call(action.spinHandler, false);
      Notification(
        "error",
        err && err.error
          ? err.error.message
          : "Session timed out. Please login again"
      );
    }
  });
}

export function* fetchConfigs() {
  yield takeEvery(actions.FETCH_APP_CONFIGS, function*(action) {
    try {
      const roles = yield call(API.common.roles);
      const schools = yield call(API.common.schools);
      const students = yield call(API.common.students);
      // const grades = yield call(API.common.grades);
      yield put({
        type: actions.FETCH_APP_CONFIGS_SUCCESS,
        roles: roles && roles.data.roles ? roles.data.roles : [],
        schools: schools && schools.data.schools ? schools.data.schools : [],
        students: students && students.data.students ? students.data.students : [],
        grades: /*grades && grades.data.grades ? grades.data.grades : */ [],
      });
    } catch (err) {
      yield call(action.spinHandler, false);
      Notification(
        "error",
        err && err.error
          ? err.error.message
          : "Session timed out. Please login again"
      );
    }
  });
}

export function* fetchUsers() {
  yield takeEvery(actions.FETCH_APP_USERS, function*(action) {
    try {
      const users = yield call(API.users.getAllStudents, formatObject(action.payload));
      yield put({
        type: actions.FETCH_APP_USERS_SUCCESS,
        users: users && users.data?.students ? users.data?.students : [],
      });
      yield call(action.spinHandler);
    } catch (err) {
      Notification(
        "error",
        err && err.error
          ? err.error.message
          : "Session timed out. Please login again"
      );
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(fetchAppVersions),
    fork(saveAppVersion),
    fork(deleteAppVersion),
    fork(fetchUsers),
    fork(fetchConfigs),
  ]);
}
